// extracted by css-extract-rspack-plugin
export default {"action":"action-kuJF6r"};